import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Helmet } from 'react-helmet-async';

const VanComfort = () => {
  return (
    <>
      <Helmet>
        <title>How Van Rentals Ensure a Comfortable Ride Every Time</title>
        <meta
          name="description"
          content="Discover how van rentals provide a comfortable ride with spacious seating, clean interiors, climate control, and reliable service for group travel."
        />
      </Helmet>

      <div className="bg-[#fff] w-full flex flex-col">
        <section
          className="hero--container relative flex flex-col justify-center w-full bg-no-repeat bg-cover bg-center pt-[65px] mt-[140px] md:h-[60vh]"
          style={{ backgroundImage: `url('../images/van-comfort.jpg')` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
          <div className="relative z-10">
            <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
              How Van Rentals Ensures a Comfortable Ride Every Time
            </h1>

            <div className="flex justify-center items-center gap-4 mt-10 md:text-sm text-xs mb-2">
              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faClock} className="w-4" />
                <p className="blog-publish-date">12/10/2025</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faComment} className="w-4" />
                <p className="blog-publish-date">5 Comments</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faBookmark} />
                <p className="blog-publish-date">1940 Views</p>
              </div>
            </div>
          </div>
        </section>

        <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
          <div className="mx-auto max-w-screen-md">
            <p className="pb-4 text-justify leading-7">
              Whether you're heading to a wedding, transporting employees to a corporate event, or planning a family getaway, comfort matters. At JJ Van Rental, ensuring a smooth and relaxing ride is a top priority. We believe transportation should be stress-free, especially when you’re traveling with a group.
            </p>

            <p className="pb-4 text-justify leading-7">
              Our fleet includes well-maintained, spacious passenger vans that cater to a variety of needs. From cozy seating with ample legroom to efficient climate control and smooth suspension systems, every van is designed with passenger comfort in mind. We offer options for both small and large groups, making sure no one feels cramped or left out.
            </p>

            <p className="pb-4 text-justify leading-7">
              What sets us apart is our attention to detail. Each van goes through regular inspections and cleaning to ensure you receive a vehicle that feels brand new. Clean interiors, quiet cabins, and smooth handling all contribute to a pleasant travel experience, no matter the distance.
            </p>

            <p className="pb-4 text-justify leading-7">
              For added convenience, we offer delivery and pickup services directly to your airport, office, or home location. This means you can start your journey without unnecessary hassle or delays. Our drivers are punctual and professional, and our customer service team is always ready to support your needs before, during, and after your trip.
            </p>

            <p className="pb-4 text-justify leading-7">
              Whether it’s a short-term rental for a single event or a long-term van for company operations, comfort is never compromised. We invest in quality vehicles and customer care because your satisfaction and safety are our top concerns.
            </p>

            <p className="pb-4 text-justify leading-7">
              At JJ Van Rental, it’s not just about getting you from one place to another—it’s about making sure the journey is just as enjoyable as the destination. Book your next van with us and experience the difference comfort makes.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <div className="max-w-screen-md mx-auto rounded-md px-4 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            {/* Tags Section */}
            <div className="flex flex-wrap gap-2">
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Van Comfort</p>
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Group Travel</p>
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Event Transport</p>
            </div>

            {/* Social Buttons Section */}
            <div className="flex flex-wrap items-center gap-3">
              <div className="flex items-center bg-[#42599E] px-3 py-2 rounded-lg text-white">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebook} className="mr-2" /> Share
                </a>
              </div>
              <div className="flex items-center bg-[#55ACEE] px-3 py-2 rounded-lg text-white">
                <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faTwitter} className="mr-2" /> Tweet
                </a>
              </div>
              <div className="flex items-center bg-[#34AF23] px-3 py-2 rounded-lg text-white">
                <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> WhatsApp
                </a>
              </div>
              <div className="flex items-center bg-[#0798CF] px-3 py-2 rounded-lg text-white">
                <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faLinkedin} className="mr-2" /> LinkedIn
                </a>
              </div>
            </div>
          </div>

        </section>
      </div>
    </>
  );
};

export default VanComfort;